import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const EthnicityDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Ethnicity"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Ethnicity">
                {getFieldDecorator('ethnicity', {
                 initialValue: data.ethnicity,
                  rules: [{ required: true, message: 'Please input the Ethnicity!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default EthnicityDialogForm;
